const IMAGES = {
  hero: require("../LandingPage/hero.jpg"),
  herobanner: require("../LandingPage/herosection/herobanner.webp"),
  herobanner2: require("../LandingPage/herosection/herobanner2.jpg"),
  // ✅ Reviewer images (these exist in your folder)
    rev1: require("../../images/LandingPage/reviewban-1.png"),
  rev2: require("../../images/LandingPage/reviewban-2.png"),
  rev3: require("../../images/LandingPage/reviewban-3.png"),
  rev4: require("../../images/LandingPage/reviewban-4.png"),
  rev5: require("../../images/LandingPage/reviewban-5.png"),
  rev6: require("../../images/LandingPage/reviewban-6.png"),
  rev7: require("../../images/LandingPage/reviewban-7.png"),
  rev8: require("../../images/LandingPage/reviewban-8.png"),
  rev9: require("../../images/LandingPage/reviewban-9.png"),
  rev10: require("../../images/LandingPage/reviewban-10.png"),
  rev11: require("../../images/LandingPage/reviewban-11.png"),
  rev12: require("../../images/LandingPage/reviewban-12.png"),
  rev13: require("../../images/LandingPage/reviewban-13.png"),
  rev14: require("../../images/LandingPage/reviewban-14.png"),
  rev15: require("../../images/LandingPage/reviewban-15.png"),
  rev16: require("../../images/LandingPage/reviewban-16.png"),
  rev17: require("../../images/LandingPage/reviewban-17.png"),
  rev18: require("../../images/LandingPage/reviewban-18.png"),
  rev19: require("../../images/LandingPage/reviewban-19.png"),
  rev20: require("../../images/LandingPage/reviewban-20.png"),
  rev21: require("../../images/LandingPage/reviewban-21.png"),
  rev22: require("../../images/LandingPage/reviewban-22.png"),
  rev23: require("../../images/LandingPage/reviewban-23.png"),
  rev24: require("../../images/LandingPage/reviewban-24.png"),
  whatsapp: require("../LandingPage/whatsapp.png"),
  thirdparty: require("../LandingPage/thirdparty.jpg"),
  security: require("../LandingPage/security.png"),
  hasslefree: require("../LandingPage/hasslefree.png"),
  cotravel: require("../LandingPage/cotravel.png"),
  hm01: require("../../images/LandingPage/herosection/hm01.jpg"),
  hm02: require("../../images/LandingPage/herosection/hm02.jpg"),
  hm03: require("../../images/LandingPage/herosection/hm03.jpg"),
  hm04: require("../../images/LandingPage/herosection/hm04.jpg"),
  hm05: require("../../images/LandingPage/herosection/hm05.jpg"),
  hmlogo: require("../../images/hmlogo.png"),
  hmlogo2: require("../../images/hmlogo2.png"),
  tte2: require("../../images/LandingPage/tte2.jpeg"),
  why1: require("../../images/LandingPage/1.jpeg"),
  why2: require("../../images/LandingPage/2.jpeg"),
  why3: require("../../images/LandingPage/3.jpeg"),
  why4: require("../../images/LandingPage/4.jpeg"),
  why5: require("../../images/LandingPage/5.jpeg"),
  contact: require("../../images/Contact/contact.webp"),
  contact2: require("../../images/Contact/contact2.webp"),
  hmlogo: require("../../images/LandingPage/logo/hmlogo.png"),
  aboutimg: require("../../images/About/aboutimg.jpg"),
  about2: require("../../images/LandingPage/herosection/herobanner2.jpg"),
  about3: require("../../images/About/about3.webp"),

  t1: require("../../images/LandingPage/t1.png"),
  t2: require("../../images/LandingPage/t2.png"),
  t3: require("../../images/LandingPage/t3.png"),
  t4: require("../../images/LandingPage/t4.png"),
  t5: require("../../images/LandingPage/t5.png"),
  t6: require("../../images/LandingPage/t6.png"),
};

export default IMAGES;
